export * from './BeforeAndAfter';

import { BeforeAndAfter } from './BeforeAndAfter';

export default BeforeAndAfter;
